import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

export class HttpBaseService<T> {
  private headers = new HttpHeaders();
  private endpoint:string;
  constructor(
    private httpClient: HttpClient, url: string,
  ) {

    this.headers = this.headers.set('Content-Type', 'application/json');
    this.headers = this.headers.set('Accept', 'application/json');
    this.headers = this.headers.set('X-Auth-Token', localStorage.getItem('tkCocred'));

    this.endpoint = environment.apiUrl + url;
  }
  
  getAll() {
    return this.httpClient.get<Array<T>>(this.endpoint, { headers: this.headers ,observe: 'response' });
  }
  getSingle(id: number) {
    return this.httpClient.get<T>(`${this.endpoint}${id}`, { headers: this.headers });
  }

  getSingleByObjeto(toAdd: T, url) {
    return this.httpClient.post<T>(`${this.endpoint}/${url}`, toAdd, { headers: this.headers });
  }

  add(toAdd: T) {
    return this.httpClient.post<T>(this.endpoint, toAdd, { headers: this.headers });
  }

  postUrl(toAdd: T,url:string ) {
    return this.httpClient.post<T>(`${this.endpoint}/${url}`, toAdd, { headers: this.headers });
  }

  update(toUpdate: T) {
    return this.httpClient.put<T>(`${this.endpoint}`,
      toUpdate,
      { headers: this.headers });
  }
  delete(id: number) {
    return this.httpClient.delete(`${this.endpoint}/${id}`, { headers: this.headers });
  }

  public setAction(value: string): void{
    this.endpoint = environment.apiUrl + value;
  }

  getHeaders() : any{
    return this.headers;
  }

  getHttpClient() : HttpClient{
    return this.httpClient;
  }

  getEndpoint() : any{
    return this.endpoint;
  }

}
